import AdyenCheckout from '@adyen/adyen-web';
import config from '../../config';
import {fetchProvider} from '../../utils/fetchProvider';
import {redirectTo} from '../../utils/helpers';
import {PAYMENT_AUTH_RETRY_DELAY} from '../../consts';

export const getInitData = ({languageCode, paymentSessionId}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getZepzPayinInitData`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    return fetchProvider(url.toString(), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).catch(err => {
        throw new Error(`Zepz Payin init data: ${err.message}`);
    });
};

export const getCards = async ({languageCode, paymentSessionId}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getZepzPayinCards`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    return fetchProvider(url.toString(), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).catch(err => {
        throw new Error(`Zepz Payin cards: ${err.message}`);
    });
};

export const getVerificationStatus = async ({languageCode, paymentSessionId, data}) => {
    const url = new URL(
        `/${languageCode}/payments-integrations-webapp/props/getZepzPayinVerificationStatus`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);
    url.searchParams.set('threeDSResult', data.details.threeDSResult);

    return fetchProvider(url.toString(), {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).catch(err => {
        throw new Error(`Zepz Payin verification status: ${err.message}`);
    });
};

export const handleOnAdditionalDetails = ({languageCode, paymentSessionId}) => ({data}) =>
    getVerificationStatus({
        paymentSessionId,
        languageCode,
        data
    }).then(({redirectUrl}) => redirectTo(redirectUrl));

export const continueWith3ds = ({
    action: actionString
}, {
    languageCode, container, paymentSessionId
}) => {
    const action = JSON.parse(actionString);

    const configuration = {
        locale: languageCode,
        environment: config.zepzPayinAdyen.env,
        clientKey: config.zepzPayinAdyen.key,
        onAdditionalDetails: handleOnAdditionalDetails({languageCode, paymentSessionId})
    };

    const threeDSConfiguration = {
        challengeWindowSize: '02'
    };

    return new AdyenCheckout(configuration).then(checkout =>
        checkout.createFromAction(
            action,
            threeDSConfiguration
        ).mount(`#${container.current.id}`));
};

export const initTransaction = ({
    platform,
    csrfToken,
    isNewCard,
    threeDSData,
    body: {
        paymentSourceId,
        expiry: {
            month,
            year
        } = {},
        bin,
        panSuffix,
        tokenexToken,
        tokenexHash,
        schema,
        cvv,
        save = true
    }
}) => {
    const url = `${window.location.href}/authPayment`;

    const {colorDepth, height: screenHeight, width: screenWidth} = window.screen;

    return fetchProvider(url, {
        retryDelay: () => PAYMENT_AUTH_RETRY_DELAY,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'csrf-token': csrfToken
        },
        body: JSON.stringify({
            isNewCard,
            platform,
            paymentSourceId,
            expiry: {
                month,
                year
            },
            bin,
            panSuffix,
            tokenexToken,
            tokenexHash,
            schema,
            cvv,
            save,
            deviceData: {
                colorDepth,
                screenHeight,
                screenWidth,
                timeZoneOffset: new Date().getTimezoneOffset()
            }
        })
    })
        .then(result =>
            (result?.continue3ds ?
                continueWith3ds(result.payload, threeDSData) :
                redirectTo(result.redirectUrl)))
        .catch(err => {
            throw new Error(`Zepz Payin init transaction: ${err.message}`);
        });
};

export const deleteCard = ({
    cardId,
    csrfToken
}) => {
    const url = `${window.location.href}/deleteCard`;

    return fetchProvider(url, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'csrf-token': csrfToken
        },
        body: JSON.stringify({
            cardId
        })
    }).catch(err => {
        throw new Error(`Zepz Payin delete card: ${err.message}`);
    });
};


export default {
    getInitData,
    getCards,
    getVerificationStatus,
    initTransaction,
    deleteCard
};
